import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
export default (function ($prop, _ref) {
  var $on = _ref.$on,
      $ = _ref.$,
      $f7 = _ref.$f7;
  var pn = 'div[data-name="chuyen-ban-ton"]';
  var $list;
  var $branches;

  var branchRow = function branchRow(branch) {
    var $branchRow = $("<tr><td colspan=\"4\" class=\"text-bold text-color-orange branch-row\">".concat(branch.name, "</td></tr>"));
    var $li = $("<li><a>".concat(branch.name, "</a></li>"));
    $branches.append($li);
    $li.click(function (e) {
      var position = $branchRow.offset();
      $(pn + ' .page-content').scrollTop(position.top - 100, 1000);
    });
    return $branchRow;
  };

  var dataRow = function dataRow(row) {
    var red = parseInt(row.qty_ban) === 0 ? 'text-color-red' : '';
    return $("\n    <tr class=\"product-row\" data-code=\"".concat(row.code.toLowerCase(), "\" data-name=\"").concat(Utils.removeVietnameseTones(row.name).toLowerCase(), "\">\n      <td>\n        <div class=\"gray-smaller\">").concat(row.code, "</div>\n        <div>").concat(row.name, "</div>\n      </td>\n      <td>").concat(row.qty_chuyen, "</td>\n      <td class=\"").concat(red, "\">").concat(row.qty_ban, "</td>\n      <td class=\"gray-smaller\">").concat(moment(row.ngay_chuyen).format(Base.dateFormat), "</td>\n    </tr>\n  "));
  };

  var display = function display(rows) {
    //Clear bảng
    $list.html('');
    var currentBranch = 0;
    if (rows.length === 0) return;
    var firstRow = rows[0];
    $(pn + " span[data-field=\"thoigian_ban\"]").text(firstRow.thoigian_ban);
    $(pn + " span[data-field=\"baocao_at\"]").text(moment(firstRow.baocao_at).format(Base.dateTimeFormat));
    rows.map(function (row) {
      //Lấy tên cơ sở
      var viewingIdBranch = parseInt(row.id_branch);

      if (viewingIdBranch !== currentBranch) {
        currentBranch = viewingIdBranch;
        var branch = Base.initdata.branches_noshift.find(function (b) {
          return b.id === currentBranch;
        }) || {
          id: '',
          name: ' - '
        };
        $list.append(branchRow(branch));
      } else {
        $list.append(dataRow(row));
      }
    });
  };

  $on('pageAfterIn', function () {
    $list = $(pn + ' .table-baocao tbody');
    $branches = $(pn + ' .branches-list'); //Check cached

    if (Base.baocao_chuyenban !== undefined && Base.baocao_chuyenban !== null) {
      display(Base.baocao_chuyenban);
    } else {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var rows;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Base.getXuatNhapTonData();

              case 2:
                rows = _context.sent;
                display(rows);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } //Tìm kiếm


    $(pn + ' input[type="search"]').change(function (e) {
      var ss = $(e.target).val().trim();

      if (ss === '') {
        $list.find('tr').removeClass('display-none');
        return;
      }

      if (ss.length < 3) return;
      ss = Utils.removeVietnameseTones(ss).toLowerCase(); //Ẩn tất cả các dòng

      $list.find('tr.product-row').addClass('display-none'); //Tìm và so sánh các dòng phù hợp

      $list.find('tr.product-row').each(function () {
        var $tr = $(this);
        var code = $tr.data('code');
        var name = $tr.data('name');
        if (code.indexOf(ss) !== -1 || name.indexOf(ss) !== -1) $tr.removeClass('display-none');
      });
    }); //Bỏ tìm kiếm 

    $(pn + ' .clear-search').click(function (e) {
      $list.find('tr').removeClass('display-none');
    }); //Cập nhật dữ liệu

    $(pn + ' .reload-button').click( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var rows;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $branches.html('');
                $list.html('<tr><td class="text-align-center">Đang cập nhật dữ liệu</td></tr>');
                _context2.next = 4;
                return Base.getXuatNhapTonData();

              case 4:
                rows = _context2.sent;
                display(rows);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()); //goto top

    $(pn + ' .goto-top').click(function (e) {
      $(pn + ' .page-content').scrollTop(0, 500);
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="chuyen-ban-ton">
  <div class="searchbar-backdrop"></div>
  <div class="searchbar">
    <div class="searchbar-inner">
      <div class="searchbar-input-wrap">
        <input type="search" placeholder="Gõ mã hoặc tên hàng để tìm kiếm" />
        <i class="searchbar-icon"></i>
        <span class="input-clear-button clear-search"></span>
      </div>
    </div>
  </div>
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left"></div>
      <div class="title">Báo cáo hàng hoá trong 2 tuần</div>
    </div>
  </div>
  <div class="fab fab-right-bottom">
    <a class="goto-top">
      <i class="icon f7-icons" style="font-size: 20px;">arrow_up_square_fill</i>
    </a>
  </div>
  <div class="page-content">
    <div class="margin">
      <div>Báo cáo hàng chuyển/bán từ <span data-field="thoigian_ban"></span></div>
      <div class="gray-smaller">Lập báo cáo: <span data-field="baocao_at">-</span></div>
    </div>

    <div class="margin text-align-center">
      <a class="reload-button">Cập nhật dữ liệu</a>
    </div>

    <div class="margin">
      <ul class="branches-list">
      </ul>
    </div>

    <div class="data-table card">
      <table class="table-baocao">
        <thead>
          <tr>
            <th>Mã/Tên hàng</th>
            <th>SL</th>
            <th>Bán</th>
            <th>Ngày chuyển</th>
          </tr>
        </thead>
        <tbody>         
          <tr><td class="text-align-center">Đang cập nhật dữ liệu</td></tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
});